import { render } from "./NerpathamAdd.vue?vue&type=template&id=db520fca&scoped=true"
import script from "./NerpathamAdd.vue?vue&type=script&lang=js"
export * from "./NerpathamAdd.vue?vue&type=script&lang=js"

import "./NerpathamAdd.vue?vue&type=style&index=0&id=db520fca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db520fca"]])

export default __exports__